import styled from '@emotion/styled';

import { BasicFlex } from '../../../utils/Common';

import { truncate } from 'lodash';

import { Tooltip } from '@mui/material';

const Code = styled.div`

`;

const Sku = styled.div`
  font-family: 'Roboto Mono', 'SF Mono', Menlo, Consolas, monospace;
  font-size: 1.1rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.5);
  margin-top: 3px;
  /* letter-spacing: 0.2px; */
  /* width: max-content; */
`;

const WigItem = ({ wig_id, sku, trunc = true }) => {

  return (
    <BasicFlex dir="column" gap="0">
      <Code>{wig_id}</Code>
      <Tooltip title={sku}><Sku>{trunc ? truncate(sku, { length: 25 }) : sku}</Sku></Tooltip>
    </BasicFlex>
  )
};

export default WigItem;